import superagentPromisePlugin from 'superagent-promise-plugin'
import http_agent from 'sync/http_agent'

import config from 'config'
import { detectLanguage } from 'helpers/functions'

const language = detectLanguage()

function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function getThemesData(slideId) {
	return http_agent.post(config.services + 'themes/get')
		.send({
			slideId,
			language,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

export default {
	getThemesData,
}
